export const AECB_CONSENT_PENDING = "AECB_CONSENT_PENDING";
export const IPA_WITHOUT_AMOUNT = "IPA_WITHOUT_AMOUNT";
export const IPA_WITH_AMOUNT = "IPA_WITH_AMOUNT";
export const REJECTED = "REJECTED";
export const INELIGIBLE = "INELIGIBLE";
export const DECLINE = "DECLINE";
export const EMPTY = null;
